module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Memolife anbefaler"},"en":{"title":"Memolife recommends"}}')
  delete Component.options._Ctor
}
